import { render, staticRenderFns } from "./OverlayModuleSignUp.vue?vue&type=template&id=22842f5a&scoped=true&"
import script from "./OverlayModuleSignUp.vue?vue&type=script&lang=js&"
export * from "./OverlayModuleSignUp.vue?vue&type=script&lang=js&"
import style0 from "./OverlayModuleSignUp.vue?vue&type=style&index=0&id=22842f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22842f5a",
  null
  
)

export default component.exports